import { gql } from '@apollo/client';

export const CREATE_LECTURE_MATERIAL_CATEGORIES = gql`
  mutation insert_lecture_material_category($objects: [lecture_material_category_insert_input!]!) {
    insert_lecture_material_category(objects: $objects) {
      affected_rows
    }
  }
`;

export const DELETE_LECTURE_MATERIAL_CATEGORY = gql`
  mutation delete_lecture_material_category($where: lecture_material_category_bool_exp!) {
    delete_lecture_material_category(where: $where) {
      affected_rows
    }
  }
`;

export const LECTURE_MATERIAL_CATEGORIES = gql`
  subscription lecture_material_categories(
    $where: lecture_material_category_bool_exp
    $order_by: [lecture_material_category_order_by!]
  ) {
    lecture_material_category(where: $where, order_by: $order_by) {
      name
      id
    }
  }
`;

export const UPDATE_LECTURE_MATERIAL_CATEGORY = gql`
  mutation update_lecture_material_category(
    $where: lecture_material_category_bool_exp!
    $_set: lecture_material_category_set_input
  ) {
    update_lecture_material_category(where: $where, _set: $_set) {
      affected_rows
    }
  }
`;

export const LECTURE_MATERIAL_CATEGORY = gql`
  query lecture_material_category($where: lecture_material_category_bool_exp) {
    lecture_material_category(where: $where) {
      id
      name
    }
  }
`;
